// Central feature flags registry
// Define canonical keys, default values, and typed helper utilities

export const FEATURE_FLAGS = {
  ENABLE_ADS: 'ENABLE_ADS',
  GOOGLE_AUTH: 'GOOGLE_AUTH',
  APPLE_AUTH: 'APPLE_AUTH',
  EMAIL_NOTIFICATIONS: 'EMAIL_NOTIFICATIONS',
  FPS_PAYMENTS: 'FPS_PAYMENTS',
  PAYME_PAYMENTS: 'PAYME_PAYMENTS',
  DEBUG_MODE: 'DEBUG_MODE',
  WHATSAPP_SERVICE_AVAILABLE: 'WHATSAPP_SERVICE_AVAILABLE',
  ENABLE_PHONE_LOGIN: 'ENABLE_PHONE_LOGIN',
  ENABLE_WHATSAPP_MFA: 'ENABLE_WHATSAPP_MFA',
  ENABLE_AUTOMATED_WHATSAPP_VERIFICATION: 'ENABLE_AUTOMATED_WHATSAPP_VERIFICATION',
  ENABLE_MULTILINGUAL: 'ENABLE_MULTILINGUAL',
  ENABLE_SOCIAL_FACEBOOK: 'ENABLE_SOCIAL_FACEBOOK',
  ENABLE_SOCIAL_INSTAGRAM: 'ENABLE_SOCIAL_INSTAGRAM',
  ENABLE_SOCIAL_LINKEDIN: 'ENABLE_SOCIAL_LINKEDIN',
  ENABLE_SOCIAL_TWITTER: 'ENABLE_SOCIAL_TWITTER',
} as const;

export type FeatureFlagKey = keyof typeof FEATURE_FLAGS;

// Default states (authoritative fallback when DB missing)
export const FEATURE_FLAG_DEFAULTS: Record<FeatureFlagKey, boolean> = {
  ENABLE_ADS: true,
  GOOGLE_AUTH: true,
  APPLE_AUTH: false,
  EMAIL_NOTIFICATIONS: true,
  FPS_PAYMENTS: false,
  PAYME_PAYMENTS: false,
  DEBUG_MODE: false,
  WHATSAPP_SERVICE_AVAILABLE: false,
  ENABLE_PHONE_LOGIN: false,
  ENABLE_WHATSAPP_MFA: false,
  ENABLE_AUTOMATED_WHATSAPP_VERIFICATION: false,
  ENABLE_MULTILINGUAL: false,
  ENABLE_SOCIAL_FACEBOOK: true,
  ENABLE_SOCIAL_INSTAGRAM: true,
  ENABLE_SOCIAL_LINKEDIN: true,
  ENABLE_SOCIAL_TWITTER: true,
};

// Utility: derive a strict array of keys
export const ALL_FEATURE_FLAG_KEYS: FeatureFlagKey[] = Object.keys(FEATURE_FLAGS) as FeatureFlagKey[];

// Helper to coerce raw DB entries into typed record with defaults applied
export function buildFeatureFlags(overrides: Partial<Record<string, string>>): Record<FeatureFlagKey, boolean> {
  const out: Record<FeatureFlagKey, boolean> = { ...FEATURE_FLAG_DEFAULTS };
  for (const key of ALL_FEATURE_FLAG_KEYS) {
    if (overrides[key] != null) {
      out[key] = overrides[key] === 'true';
    }
  }
  return out;
}
